module.exports = __webpack_public_path__ + "img/tab-sand-tank-selected.c7526529.png";